import { Injectable,Inject  } from '@angular/core';
import { DOCUMENT } from '@angular/common';


@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  constructor(@Inject(DOCUMENT) private document: Document) {}

  showPreLoader() {
    const preloader = this.document.getElementById('preloader');
    if (preloader) {
      preloader.style.display = 'block';
    }
  }

  hidePreLoader() {
    const preloader = this.document.getElementById('preloader');
    if (preloader) {
      preloader.style.display = 'none';
    }
  }

}
